<template>
  <v-card height="100%">
    <v-card-title height="100%">
      <v-row row>
        <v-app-bar flat>
          <v-toolbar-title>{{ resx.labels.contact }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
      </v-row>
    </v-card-title>
    <form @submit.prevent="send()" novalidate>
      <v-card-text>
        <v-container fluid>
          <v-row row wrap>
            <v-col cols="12">
              <v-text-field
                v-model="contact.subject"
                :label="resx.labels.subject"
                name="subject"
                :data-vv-as="resx.labels.subject"
                v-validate="'required'"
                :error-messages="errors.collect('subject')"
              />
            </v-col>
          </v-row>

          <v-row row wrap>
            <v-col cols="12">
              <v-textarea
                v-model="contact.message"
                :label="resx.labels.message"
                name="message"
                :data-vv-as="resx.labels.message"
                v-validate="'required'"
                :error-messages="errors.collect('message')"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions style="padding-right: 24px">
        <v-spacer></v-spacer>
        <v-btn class="primary" type="submit" :disabled="!isValidForm">{{
          resx.labels.send
        }}</v-btn>
      </v-card-actions>
    </form>
  </v-card>
</template>

<script>
"use strict";

import contactService from "@/services/ContactService";

export default {
  data() {
    return {
      contact: {
        subject: null,
        mail: null,
        message: null
      }
    };
  },
  methods: {
    async send() {
      const result = await contactService.sendContact(this.contact);
      if (result) {
        await this.botConfirmDialog({
          title: `${this.resx.labels.contact}`,
          content: `${this.resx.messages.contactSuccessMessage}`
        });
        this.contact.subject = null;
        this.contact.mail = null;
        this.contact.message = null;
        this.$router.back();
      }
    }
  }
};
</script>
